
import Button from "../views/components/Button";
import PointerEvents from "../../src/const/PointerEvents";
import BaseView from "../views/BaseView";
import * as GameCommands from "../../src/commands/GameCommands";
import GameFactory from "../factories/BaseGameFactory";
import CommandManager from "../../src/commands/CommandManager";
import { Commands } from "../commands/CommandEnum";

class InterractionManager {

    // protected commandsSet: Map<string , (...args: any[]) => void>;
    protected commandMap: Map<BaseView, IInterraction[]>;

    constructor() {
        // this.commandsSet = new Map<string , (...args: any[]) => void>();
        this.commandMap = new Map<BaseView, IInterraction[]>();
        // this.initDefaultCommads()
    }

    // initDefaultCommads() {
    //     this.setCommand(Commands.SPIN, GameCommands.SpinCommand);
    //     this.setCommand(Commands.SKIP, GameCommands.SkipCommand);

    //     this.setCommand(Commands.TOGGLE_SPACE_TO_SPIN, GameCommands.ToggleSpaceToSpinCommand);
    //     this.setCommand(Commands.TOGGLE_TURBO_SPIN, GameCommands.ToggleTuboSpinCommand);

    //     this.setCommand(Commands.START_AUTOPLAY, GameCommands.StartAutoplayCommand);
    //     this.setCommand(Commands.STOP_AUTOPLAY, GameCommands.StopAutoplayCommand);
    //     this.setCommand(Commands.CLEAR_AUTOPLAY_LIMITS, GameCommands.ClearAutoplayLimitsCommand);
    //     this.setCommand(Commands.SET_AUTOPLAY_LOSS_LIMIT, GameCommands.SetAutoplayLossLimitCommand);
    //     this.setCommand(Commands.SET_AUTOPLAY_SINGLE_WIN_LIMIT, GameCommands.SetAutoplaySingleWinLimitCommand);
    //     this.setCommand(Commands.SET_AUTOPLAY_TOTAL_WIN_LIMIT, GameCommands.SetAutoplayTotalWinLimitCommand);
    //     this.setCommand(Commands.TOGGLE_AUTOPLAY_STOP_ON_ANY_WIN, GameCommands.ToggleAutoplayStopOnWinCommand);
    //     this.setCommand(Commands.TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN, GameCommands.ToggleAutoplayStopOnFeatureCommand);

    //     this.setCommand(Commands.CYCLE_STAKE_VALUE, GameCommands.IterateStakeCommand);
    //     this.setCommand(Commands.CYCLE_BET_VALUE, GameCommands.IterateBetCommand);
    //     this.setCommand(Commands.SET_MAX_BET, GameCommands.SetMaxBetCommand);
    //     this.setCommand(Commands.CYCLE_COIN_VALUE, GameCommands.IterateCoinsCommand);
    //     this.setCommand(Commands.CYCLE_TOTAL_BET, GameCommands.IterateTotalBetCommand);

    //     this.setCommand(Commands.TOGGLE_SETTINGS, GameCommands.ToggleSettingsCommand);
    //     this.setCommand(Commands.TOGGLE_AUTOPLAY_SETTINGS, GameCommands.ToggleAutoplaySettingsCommand);
    //     this.setCommand(Commands.TOGGLE_BET_SETTINGS, GameCommands.ToggleBetSettingsCommand);
    //     this.setCommand(Commands.TOGGLE_PAYTABLE, GameCommands.TogglePaytableCommand);
    //     this.setCommand(Commands.TOGGLE_AUTOPLAY_POPUP, GameCommands.ToggleAutoplayPopupCommand);
    //     this.setCommand(Commands.TOGGLE_BET_POPUP, GameCommands.ToggleBetPopupCommand);

    //     this.setCommand(Commands.TOGGLE_SOUND_FX, GameCommands.ToggleSoundFXCommand);
    //     this.setCommand(Commands.TOGGLE_MUSIC, GameCommands.ToggleMusicCommand);
    //     this.setCommand(Commands.TOGGLE_MASTER_SOUND, GameCommands.ToggleMasterSoundCommand);
    //     this.setCommand(Commands.SET_MASTER_VOLUME, GameCommands.SetMasterVolumeCommand);

    //     // TODO set the rest of them :)
    // }

    public assign(commands: Commands | string | Commands[] | string[], button: BaseView, commandArgs?: any, triggerEvent: PointerEvents = PointerEvents.DOWN )
    {
        if (!Array.isArray(commands)) {
            commands = [commands];
        }
        commands.forEach(commandName => {
            const command = this.buildCommand(commandName, commandArgs, triggerEvent);
            if (!this.commandMap.has(button)) {
                this.commandMap.set(button, []);
            }

            this.commandMap.get(button).push(command);

            button.on(command.trigger, this.executeCommand.bind(this, command));
        });
    }

    public unAssign(button: BaseView) {
        if (this.commandMap.has(button)) {
            this.commandMap.get(button).forEach((command) => {
                button.off(command.trigger,  this.executeCommand.bind(this, command));
            });
        }
    }

    protected executeCommand(command) {
        CommandManager.execute(command.command, command.args);
    }

    public clear() {
        this.commandMap.forEach((commands, element) => {
            this.unAssign(element);
        });
        this.commandMap.clear();
    }

    // public execute( command: ICommand) {
    //     this.commandsSet.get(command.command)(command.args);
    // }

    protected buildCommand(commandName: Commands | string, commandArgs?: any, triggerEvent: PointerEvents = PointerEvents.DOWN ): IInterraction {
        if ( CommandManager.has(commandName)) {
            return {
                command: commandName,
                args: commandArgs,
                trigger: triggerEvent.toString()
            }
        } else {
            throw new Error(("Command not set"));
        }
    }

    // public setCommand(commandName: Commands | string, command: (...args: any[]) => void) {
    //     this.commandsSet.set(commandName, command);
    // }
}

export interface IInterraction {
    command: string;
    args: any;
    trigger?: string;
}

export default InterractionManager;
